'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../helpers/utils');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  var title = props.title,
      className = props.className,
      href = props.href,
      action = props.action,
      disabled = props.disabled,
      hideTitle = props.hideTitle,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      newWindow = props.newWindow,
      elementRef = props.elementRef,
      small = props.small,
      type = props.type,
      width = props.width;


  var newProps = {
    className: (0, _utils.classNames)('Button', [className, type, width], { hideTitle: hideTitle, iconLeft: iconLeft, iconRight: iconRight, small: small })
  };

  if (elementRef) {
    newProps.ref = elementRef;
  }

  if (hideTitle) {
    newProps['aria-label'] = title;
    newProps.title = title;
  }

  var content = _react2.default.createElement(
    'span',
    null,
    iconLeft && _react2.default.createElement(_Icon2.default, { name: iconLeft }),
    !hideTitle && title,
    iconRight && _react2.default.createElement(_Icon2.default, { name: iconRight })
  );

  if (href) {
    if (newWindow) {
      newProps.target = '_blank';
      newProps.rel = 'noopener noreferrer';
    }
    return _react2.default.createElement(
      'a',
      _extends({ href: href }, newProps),
      content
    );
  }

  return _react2.default.createElement(
    'button',
    _extends({ onClick: action, disabled: disabled, type: 'button' }, newProps),
    content
  );
};

Button.propTypes = {
  /** The title of the button. */
  title: _propTypes2.default.string.isRequired,
  /** The CSS class of the block. */
  className: _propTypes2.default.string,
  /** URL to link to. */
  href: _propTypes2.default.string,
  /** Action triggered when the button is clicked. */
  action: _propTypes2.default.func,
  /** Whether the button is disabled. */
  disabled: _propTypes2.default.bool,
  /** Whether the title should be hidden (if so, it will still be available to screenreaders) */
  hideTitle: _propTypes2.default.bool,
  /** The name of the icon to display on the left side of the button. */
  iconLeft: _propTypes2.default.string,
  /** The name of the icon to display on the right side of the button. */
  iconRight: _propTypes2.default.string,
  /** Whether to open the link in a new window. */
  newWindow: _propTypes2.default.bool,
  /** Passthrough for the ref special prop. https://fb.me/react-special-props */
  elementRef: _propTypes2.default.func,
  /** Whether the button has smaller text. */
  small: _propTypes2.default.bool,
  /** The button type. */
  type: _propTypes2.default.oneOf(['primary', 'secondary', 'borderless']),
  /** The button width. */
  width: _propTypes2.default.oneOf(['full', 'fit'])
};

Button.defaultProps = {
  action: null,
  className: null,
  disabled: false,
  elementRef: null,
  hideTitle: false,
  href: null,
  iconLeft: null,
  iconRight: null,
  newWindow: false,
  small: false,
  type: 'secondary',
  width: 'fit'
};

exports.default = Button;
Button.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Button',
  'props': {
    'action': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Action triggered when the button is clicked.'
    },
    'className': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The CSS class of the block.'
    },
    'disabled': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the button is disabled.'
    },
    'elementRef': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Passthrough for the ref special prop. https://fb.me/react-special-props'
    },
    'hideTitle': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the title should be hidden (if so, it will still be available to screenreaders)'
    },
    'href': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'URL to link to.'
    },
    'iconLeft': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The name of the icon to display on the left side of the button.'
    },
    'iconRight': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The name of the icon to display on the right side of the button.'
    },
    'newWindow': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether to open the link in a new window.'
    },
    'small': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the button has smaller text.'
    },
    'type': {
      'defaultValue': {
        'value': '\'secondary\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'primary\'',
          'computed': false
        }, {
          'value': '\'secondary\'',
          'computed': false
        }, {
          'value': '\'borderless\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'The button type.'
    },
    'width': {
      'defaultValue': {
        'value': '\'fit\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'full\'',
          'computed': false
        }, {
          'value': '\'fit\'',
          'computed': false
        }]
      },
      'required': false,
      'description': 'The button width.'
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The title of the button.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Button.js
// module id = 80
// module chunks = 0